import { truncateText } from "../utils";

export const labelsPlugin = (xLabelText?: string, yLabelText?: string) => {
	return {
		id: "labelsPlugin",
		afterDatasetsDraw: (chart) => {
			const { ctx } = chart;
			const xAxis = chart.scales.x;
			ctx.save();
			ctx.textAlign = "center";
			ctx.fillStyle = "black";
			ctx.font = "14px Source Sans Pro";
			const truncatedText1 = truncateText(ctx, xLabelText || "", xAxis.width * 0.7);
			ctx.fillText(truncatedText1, (xAxis.left + xAxis.right) / 2, chart.height - 85);
			ctx.restore();

			// draw label for y
			const yAxis = chart.scales.y;
			ctx.save();
			ctx.textAlign = "center";
			ctx.fillStyle = "black";
			ctx.font = "14px Source Sans Pro";
			ctx.translate(yAxis.left - 22, (yAxis.top + yAxis.bottom) / 2);
			ctx.rotate(-Math.PI / 2);
			const truncatedText2 = truncateText(ctx, yLabelText || "", yAxis.height * 0.7);
			ctx.fillText(truncatedText2, 0, 0);
			ctx.restore();
		},
	};
};
